import { SelectOption, SelectValue } from './form-item-types';

export const toSelectValues = (values: string | string[]) => {
  return Array.isArray(values)
    ? values.map<SelectOption>((value) => ({ label: value, value }))
    : ({ label: values, value: values } as SelectOption);
};

export const fromSelectValues = (
  selectValues: SelectValue<SelectOption> | SelectValue<SelectOption, true>
) => {
  if (!selectValues) return null;

  return Array.isArray(selectValues)
    ? selectValues.map(({ value }) => value)
    : selectValues.value;
};

export const disableWheelInteraction = <T extends HTMLElement>(
  event: React.WheelEvent<T>
) => {
  const formItem = event.target as T;

  if (formItem.matches(':focus')) {
    formItem.blur();
    requestAnimationFrame(() => formItem.focus());
  }
};

export const prepareNumberValue = <T extends React.ReactText | null>(
  value: React.ReactText,
  nanValue: T
) => {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }

  return isNaN(value) ? nanValue : value;
};

export const performStep = (
  sign: '+' | '-',
  inputElement: HTMLInputElement | null,
  setter: (value: React.ReactText) => void
) => () => {
  if (!inputElement) return;

  sign === '+' ? inputElement.stepUp() : inputElement.stepDown();
  setter(inputElement.value);
  inputElement.focus();
};
